<script>
  export let fields = [];
  export let values = {};
  export let message = '';

  function setValue(fieldId, value) {
    values = { ...values, [fieldId]: value };
  }
</script>

{#if fields.length}
  <div class="p-2 bg-orange-50 border border-orange-200 rounded text-xs mb-2">
    {#if message}
      <p class="text-orange-800 mb-2">{message}</p>
    {/if}
    <div class="space-y-2">
      {#each fields as field (field.id || field.name)}
        <label class="block">
          <span class="block font-medium text-orange-900 mb-0.5">{field.name}</span>
          {#if field.options && field.options.length}
            <select
              class="w-full px-2 py-1.5 text-sm border border-orange-300 rounded-md bg-white focus:outline-none focus:ring-1 focus:ring-orange-500"
              value={values[field.id] || ''}
              on:change={(e) => setValue(field.id, e.currentTarget.value)}
            >
              <option value="">Select {field.name}…</option>
              {#each field.options as option}
                <option value={option.value}>{option.label}</option>
              {/each}
            </select>
          {:else}
            <input
              type="text"
              class="w-full px-2 py-1.5 text-sm border border-orange-300 rounded-md bg-white focus:outline-none focus:ring-1 focus:ring-orange-500"
              value={values[field.id] || ''}
              placeholder={field.name}
              on:input={(e) => setValue(field.id, e.currentTarget.value)}
            />
          {/if}
        </label>
      {/each}
    </div>
  </div>
{/if}
